/**
 * สีประจำธาตุ — แยกจาก race-model.ts เพื่อให้หน้าคู่มือ (handbook.html) ใช้ได้โดยไม่ลาก Babylon เข้ามา
 */
import type { Element } from "@wickhaven/shared";

/** สีประจำธาตุ ใช้กับวงแสงใต้ตัว จุดเรืองแสงบนตัว แผนที่ และคู่มือ */
export const ELEMENT_GLOW: Readonly<Record<Element, string>> = {
  neutral: "#c8c8c8", earth: "#c49a5a", water: "#4aa8ff", fire: "#ff6a2a", wind: "#8af0a8",
  poison: "#a85aff", holy: "#ffe58a", dark: "#7a3fbf", ice: "#aee8ff",
};
